import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { DragHandleProps } from './drag-handle.type';

export const DragHandle = ({
  onClose,
  onTouchStart,
  onTouchMove,
  onTouchEnd,
  onTouchCancel,
  className,
}: DragHandleProps) => {
  const { t } = useTranslation();

  return (
    <button
      type='button'
      className={classNames('flex w-full items-center justify-center h-7 cursor-grab touch-none', className)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') onClose();
      }}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
      onTouchCancel={onTouchCancel}
      aria-label={t('common:dragToClose')}>
      <div className='w-10 h-1 bg-transparent-20 rounded-full' />
    </button>
  );
};
